import React, { useState, useEffect } from 'react';
import { BiographyContext } from './DataContext';
import axios from "axios";
import WebAppConfig from '../components/configuration/webapp-config';

export const BiographyState = ({ children }) => {
    const [bios, setBios] = useState([]);
    const [loading, setLoading] = useState(false);
    const { config, isLoading: configLoading } = WebAppConfig();

    const apiUrl = 'https://apievt.lacnic.net/wp-json/wp/v2/biographies';
    const pageParam = '?per_page=100';

    useEffect(() => {
        const fetchSponsors = async () => {
            // No hacer la llamada si no tenemos el ID o si config está cargando
            if (!config.currentEventID || configLoading) {
                return;
            }

            setLoading(true);
            try {
                const currentEvent = `&our_events=${config.currentEventID}`;
                const responseJSON = await axios.get(`${apiUrl}${pageParam}${currentEvent}`);
                setBios(responseJSON.data);
            } catch (error) {
                console.error('Error fetching biographies:', error);
                setBios([]); // Set empty array on error
            } finally {
                setLoading(false);
            }
        };

        fetchSponsors();
    }, [config.currentEventID, configLoading]);

    return (
        <BiographyContext.Provider value={{
            bios,
            loading: loading || configLoading // También considerar el loading de config
        }}>
            {children}
        </BiographyContext.Provider>
    );
}